import Main from './components/Main.vue';

const meta = {
  layout: 'master',
  requiresAuth: true,
};

export default [
  {
    path: '/clinical/reports',
    component: () => import(/* webpackChunkName: "clinical-reports" */ './components/Main.vue'),
    children: [
      { path: '', component: Main, meta },
    ],
    meta,
  },
];
